import React from 'react'
import Page from './components/Page'

export default function App() {
  return (
    <div>
<Page/>
    </div>
  )
}
